module.exports = __webpack_public_path__ + "73e8e726078c716d300c810e90f31d3c.png";